'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import Link from 'next/link'

const Impact = () => {
  return (
    <div className="relative">
      <img
        src="/images/home/commitments.webp"
        className="absolute left-0 top-40 z-0 opacity-[.10] "
      />
      <div className="relative pt-24 max-w-7xl w-full mx-auto px-6 lg:px-8">
        <FadeInStagger faster>
          <div className="max-w-3xl mx-auto self-stretch flex-col justify-start items-center gap-12 flex">
            <div className="flex-col justify-start items-start gap-5 flex">
              <div className="self-stretch flex-col justify-start items-center gap-3 flex">
                <FadeIn>
                  <div className="p-1 bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 flex">
                    <div className="px-2.5 py-0.5 bg-white bg-opacity-10 rounded-2xl justify-start items-center flex">
                      <div className="text-center text-white text-sm font-medium  leading-5">
                        Our Core Commitments
                      </div>
                    </div>
                  </div>
                </FadeIn>

                <FadeIn>
                  <h2 className="text-center text-white text-[36px] font-semibold leading-[44px]">
                    Turn Ambition Into Impact
                  </h2>
                </FadeIn>
              </div>
              <FadeIn>
                <p className="text-center text-[#D0D5DD] text-xl font-normal leading-[30px] md:w-[768px]">
                  Our 12 week elite incubator program is a hybrid of x8 week in
                  person and x4 weeks virtual and is designed to be intense,
                  rewarding, and life-changing. We know you have big ideas, and
                  we're here to help you make them happen.
                </p>
              </FadeIn>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-[16px] pt-16 auto-rows-auto	">
            <FadeIn className="bg-[#000000] overflow-hidden rounded-[16px] py-[20px] border border-[#34373B] col-span-12 sm:col-span-4 ">
              <img src={'/funding.svg'} />

              <div className="text-lg text-white font-[600] px-[20px] ">
                Connections that Count
              </div>
              <div className=" text-[#BBC4D2] px-[20px]">
                From pitch days with top investors to networking events with
                industry insiders, we'll make sure you're in the right rooms
                with the right people.
              </div>
            </FadeIn>
            <FadeIn className=" flex flex-col lg:flex-row md:flex-col items-end bg-[#000000] overflow-hidden rounded-[16px] pr-[20px] pt-[20px] lg:pt-0 md:pt-[20px]  border border-[#34373B] col-span-12 sm:col-span-7 row-span-2 sm:col-start-1">
              <div>
                <div className="text-lg text-white font-[600] px-[20px]">
                  Investor Presentation Week
                </div>
                <div className=" text-[#BBC4D2] px-[20px] pb-[20px]">
                  In week 12, present your startup to 500+ investors, from angel
                  funds to VCs, to secure vital funding.
                </div>
              </div>
              <img src={'/financial.svg'} />
            </FadeIn>
            <FadeIn className="bg-[#000000] overflow-hidden rounded-[16px] py-[20px] border border-[#34373B] col-span-12 sm:col-span-4 sm:col-start-5 sm:row-start-1">
              <img src={'/expert.svg'} />

              <div className="text-lg text-white font-[600] px-[20px]">
                Dynamic Curriculum
              </div>
              <div className=" text-[#BBC4D2] px-[20px]">
                Hands-on workshops, relevant projects for your company, and
                challenges that will test your limits and expand your horizons.
              </div>
            </FadeIn>
            <FadeIn className="bg-[#000000] overflow-hidden rounded-[16px] py-[20px] border border-[#34373B] col-span-12 sm:col-span-4 sm:col-start-9 sm:row-start-1">
              <img src={'/intensive.svg'} />

              <div className="text-lg text-white font-[600] px-[20px]">
                Milestones that Matter
              </div>
              <div className=" text-[#BBC4D2] px-[20px]">
                We'll set goals together and celebrate every achievement, no
                matter how small or big.
              </div>
            </FadeIn>
            <FadeIn className=" bg-[#000000] overflow-hidden flex flex-col justify-between rounded-[16px] p-[20px] border border-[#34373B] col-span-12 sm:col-span-5 sm:col-start-8 sm:row-start-2">
              <img src={'/view-week.svg'} />
              <div className="flex justify-between items-center relative z-10 mt-6">
                <span className="text-[18px] text-white leading-none font-[600]">
                  View 12 Weeks Schedule
                </span>

                <Link
                  href={'/about'}
                  className="backdrop-blur-[10px] border-[1.0625px] bg-[#4E5053]/50 hover:bg-white/40 border-[#BBC3D1] w-[34px] h-[34px] rounded-full flex items-center justify-center  "
                >
                  <CustomWhiteArrowTopIcon />
                </Link>
              </div>
            </FadeIn>
            <FadeIn className=" relative flex flex-col justify-between bg-[#000000] overflow-hidden rounded-[16px] p-[20px] border border-[#34373B] col-span-12 sm:col-span-5 sm:col-start-8 sm:row-start-3">
              <svg
                width="298"
                height="162"
                viewBox="0 0 298 162"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="absolute left-0 top-0 w-full h-full"
              >
                <g filter="url(#filter0_f_7407_33953)">
                  <circle cx="39" cy="32" r="59" fill="#0057FF" />
                </g>
                <defs>
                  <filter
                    id="filter0_f_7407_33953"
                    x="-220"
                    y="-227"
                    width="518"
                    height="518"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="100"
                      result="effect1_foregroundBlur_7407_33953"
                    />
                  </filter>
                </defs>
              </svg>

              <div className="flex justify-between items-center relative z-10">
                <Link
                  href={'/portfolio'}
                  className="border-[1.0625px] bg-[#B0BCCA] bg-opacity-[.12] hover:bg-white/40 border-[#98A2B3] w-[50px] h-[50px] rounded-full flex items-center justify-center  "
                >
                  <img src="/chatbot.png" className="w-[32px] " />
                </Link>

                <svg
                  width="41"
                  height="33"
                  viewBox="0 0 41 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7407_33962)">
                    <path
                      d="M13.6973 18.0254C20.1585 21.9917 23.3766 25.2071 27.3483 31.6571C31.319 25.2033 34.5391 21.9878 40.9993 18.0216C34.5391 14.0592 31.319 10.8428 27.3483 4.38892C23.3766 10.8428 20.1585 14.0592 13.6973 18.0254Z"
                      fill="#9C6DFF"
                    />
                    <path
                      d="M0 26.11C3.26411 28.1185 4.89089 29.7387 6.89397 32.9962C8.90472 29.7348 10.5277 28.1099 13.7879 26.11C10.5325 24.1016 8.90472 22.4805 6.89397 19.2239C4.89089 22.4805 3.26411 24.1016 0 26.11Z"
                      fill="#30D779"
                    />
                    <path
                      d="M9.76562 3.97963C11.6519 5.13784 12.5912 6.07608 13.7507 7.96021C14.9093 6.07608 15.8496 5.13784 17.7349 3.97963C15.8534 2.82237 14.9131 1.88317 13.7546 0C12.595 1.88317 11.6557 2.82237 9.76562 3.97963Z"
                      fill="#FCCE3A"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7407_33962">
                      <rect width="41" height="33" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className=" relative z-10 mt-6">
                <div className="text-[#BBC4D2] mb-3 text-base ">
                  Supported by
                </div>
                <div className="text-[18px] text-white leading-none font-[600]">
                  Our Proprietary: Annalise AI
                </div>
              </div>
            </FadeIn>
          </div>
        </FadeInStagger>
      </div>
    </div>
  )
}
export default Impact
const CustomWhiteArrowTopIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 11L11 1M11 1H1M11 1V11"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
